module.exports = __webpack_public_path__ + "static/Rectangle 65 2-e91cc5b67ee94c7fb62e037d897d3dec.png";